/* eslint-disable */
import Colors from '../../Support/Theme/Colors/Colors';

/**
 * Create styles for `<DashboardPage />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<DashboardPage />` styles
 */
const dashboardPageStyles = ({ theme }) => ({
  avatar: {
    color: theme.palette.grey[`300`],
    display: `inline-block`,
    height: theme.spacing(1) * 16,
    marginBottom: theme.spacing(1),
    opacity: 0.5,
    paddingTop: theme.spacing(1) * 2,
    width: theme.spacing(1) * 16,
  },
  cardIcon: {
    fontSize: theme.spacing(1) * 5,
  },
  cardsContainer: {
    padding: 0,
		minHeight: '350px',
		marginTop: '110px',
  },
  stickyTopBar: {
    position: 'sticky',
    top: 0, // Ensure it sticks at the top
    zIndex: 1000, // Keep it above other elements
    backgroundColor: 'white', // Ensure proper background
    padding: '10px 0', // Add some padding for better spacing
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)', // Optional: Add shadow for better visibility
    height: '80px', // Ensure it has a fixed height
    display: 'flex',
    alignItems: 'center',
  },
  tileTitle: {
    color: `white`,
    fontWeight: 500,
    marginBottom: theme.spacing(1),
  },
  clickableCard: {
    alignItems: `center`,
    color: theme.palette.grey[`900`],
    display: `flex`,
    listStyle: `none`,
    textAlign: `center`,
    textDecoration: `none`,
    borderRadius: theme.spacing(1),
    backgroundColor: Colors.boralgreen[500],
    color: `white`,
    paddingTop: theme.spacing(1) * 2.5,
    paddingBottom: 0,
    overflow: `hidden`,
  },
  tileMenuButton: {
    backgroundColor: Colors.boralgreen[500],
    borderTop: `1px solid #ffffff8c`,
    color: `white`,
    fontWeight: `normal`,
    boxShadow: `none`,
    paddingTop: 11,
    paddingBottom: 11,
    '&:hover': {
      boxShadow: `none`,
      backgroundColor: Colors.boralgreen[900],
    },
    '&:active': {
      boxShadow: `none`,
    },
    '&:focus': {
      boxShadow: `none`,
    },
  },
  tileMenuOptionDefaultIcon: {
    verticalAlign: `middle`,
    height: 16,
  },
  tileMenuOptionIcon: {
    verticalAlign: `bottom`,
  },
  personIcon: {
    color: theme.palette.grey[`300`],
    display: `inline-block`,
    fontSize: 100,
  },
  welcomeContainer: {
    marginLeft: -theme.spacing(1) * 3,
    marginTop: theme.spacing(1),
    textAlign: `center`,
  },
  welcomeText: {
    color: Colors.boralgreen[500],
  },
  welcomeSubText: {
    opacity: 0.6,
    marginBottom: theme.spacing(1),
  },
  menuLabel: {
    color: `white`,
    textTransform: `none`,
  },
});

export default dashboardPageStyles;
